import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { css } from "@emotion/core";
import Loader from "./Loader";
import Lottie from "components/Lottie";

import animationAlwaysGrey from "assets/lotties/VF_Living_Speechmark_Rotation_always_on_Lottie_Grey_300";
import animationAlwaysRed from "assets/lotties/VF_Living_Speechmark_Rotation_always_on_Lottie_Red_300";
import animationAlwaysWhite from "assets/lotties/VF_Living_Speechmark_Rotation_always_on_Lottie_White_300";

import animationDrawnGrey from "assets/lotties/VF_Living_Speechmark_Rotation_drawn_on_Lottie_Grey_300";
import animationDrawnRed from "assets/lotties/VF_Living_Speechmark_Rotation_drawn_on_Lottie_Red_300";
import animationDrawnWhite from "assets/lotties/VF_Living_Speechmark_Rotation_drawn_on_Lottie_White_300";

import animationSimpleGrey from "assets/lotties/VF_Speechmark_intro_Lottie_Grey_300";
import animationSimpleRed from "assets/lotties/VF_Speechmark_intro_Lottie_Red_300";
import animationSimpleWhite from "assets/lotties/VF_Speechmark_intro_Lottie_White_300";

const animationAlways = {
  gray: animationAlwaysGrey,
  red: animationAlwaysRed,
  white: animationAlwaysWhite
};

const animationDrawn = {
  gray: animationDrawnGrey,
  red: animationDrawnRed,
  white: animationDrawnWhite
};

const animationSimple = {
  gray: animationSimpleGrey,
  red: animationSimpleRed,
  white: animationSimpleWhite
};

// All sizes are exactly based on group specs
const largeSize = css({
  width: 300
});

const mediumSize = css({
  width: 150
});

const smallSize = css({
  width: 75
});

const tinySize = css({
  width: 30
});

const Speechmark = styled("div")(
  {
    margin: 30
  },
  props => {
    if (props.size === "large") return largeSize;
    if (props.size === "medium") return mediumSize;
    if (props.size === "small") return smallSize;
    if (props.size === "tiny") return tinySize;
  }
);

// TODO
// Specs for looping
// The ‘Living Speechmark’ versions have four markers on the timeline.
// These can be controlled using the Lottie library. When used in UI for
// loading, play the timeline from ‘Start’ marker, and then loop seamlessly
// between the ‘loopIn’ and ‘loopOut’ markers. Once whatever in the UI
// has loaded, fade out the Lottie animation (Opacity, 0.1sec, easeOut).

// The ‘Speechmark only’ version is looped simply by looping the entire
// timeline.

function LoaderSpeechmark(props) {
  let animationData = animationSimple[props.color];

  // always use simple animation when size is tiny
  if (props.size !== "tiny") {
    if (props.animation === "drawn")
      animationData = animationDrawn[props.color];
    if (props.animation === "always")
      animationData = animationAlways[props.color];
  }

  const options = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <Loader {...props}>
      <Speechmark size={props.size}>
        <Lottie
          width={"100%"}
          height={"auto"}
          options={options}
          isStopped={false}
          isClickToPauseDisabled={true}
        />
      </Speechmark>
    </Loader>
  );
}

LoaderSpeechmark.propTypes = {
  size: PropTypes.oneOf(["tiny", "small", "medium", "large"]),
  color: PropTypes.oneOf(["white", "gray", "red"]),
  animation: PropTypes.oneOf(["drawn", "always", "simple"])
};

LoaderSpeechmark.defaultProps = {
  size: "large",
  color: "gray",
  animation: "simple"
};

export default LoaderSpeechmark;
